import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import LocationManager from '@/utils/locationManager';

import { vMaska } from 'maska/vue';
import { IonicVue } from '@ionic/vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { SEOPlugin } from '@/plugins/seo';
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/buttons.css';
import './theme/inputs.css';
import './theme/layout.css';
import './theme/typography.css';
import './theme/other.css';

const app = createApp(App)
    .use(IonicVue, {
        innerHTMLTemplatesEnabled: true,
    })
    .use(router)
    .use(store)
    .use(VueReCaptcha, { siteKey: process.env.VUE_APP_CAPTCHA_KEY, loaderOptions: { autoHideBadge: true } })
    .directive('maska', vMaska);

// Install SEO Plugin after store is available with store reference
app.use(SEOPlugin, {
    defaultTitle: 'Donatos Pizza',
    titleTemplate: (title: string) => `${title} | Donatos Pizza`,
    defaultDescription: 'Order pizza online from Donatos. Fresh ingredients, Edge to Edge® toppings, and family-sized pizzas delivered to your door.',
    defaultOgImage: 'https://files.donatos.com/2023/08/03/Meta.png',
    defaultKeywords: ['pizza', 'delivery', 'donatos', 'restaurant', 'food', 'online ordering'],
    host: process.env.VUE_APP_BASE_URL || 'https://donatos.com',
    store: store,
});

//@ts-ignore
if (window.Cypress) {
    //@ts-ignore
    window.store = store;
}

LocationManager.getInstance(); // Initialize location manager

await store.dispatch('initUserData');

router.isReady().then(() => {
    app.mount('#app');
});
